import { defineStore } from 'pinia';

export const useGeneralSettings = defineStore('GeneralSettings', {
  state: () => ({
    settings: null,
  }),
});
